import { createContext } from 'react';
var PortalContext = createContext({
    createPortal: function () { },
    destroyPortal: function () { },
    updatePortal: function () { }
});
export default PortalContext;
//# sourceMappingURL=PortalContext.js.map